import {
  StarRating,
  Text,
  Circle,
  HStack,
  Icon as IconComponent,
  VStack,
  useDisclosure,
  Collapse,
  Divider,
} from '@wegroup/design-system';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { getCoverageRatingForBase } from '../../../../../services/productFactoryService';

interface Props {
  Icon: React.ReactElement;
  coverage?: number;
  isActive?: boolean;
  description?: string | null;
}

const OfferCoverage: React.FC<React.PropsWithChildren<Props>> = ({
  Icon,
  coverage,
  isActive,
  children,
  description,
}) => {
  const { isOpen, onToggle } = useDisclosure();
  const theme = useContext(ThemeContext);
  return (
    <VStack align="stretch">
      <HStack
        justify="space-between"
        onClick={onToggle}
        cursor={description ? 'pointer' : undefined}
      >
        <HStack spacing="4">
          <Circle
            bg={
              isActive
                ? theme['isImmo']
                  ? theme.secondary[500]
                  : 'gray.50'
                : 'gray.strokeAndBg'
            }
            size="10"
            p="2"
            flexShrink={0}
            sx={{
              svg: {
                path: {
                  fill: theme['isImmo'] ? 'white' : 'gray.300',
                },
              },
            }}
            color={
              isActive
                ? theme['isImmo']
                  ? 'white'
                  : 'primary.500'
                : 'gray.300'
            }
          >
            {Icon}
          </Circle>
          <HStack>
            <Text>{children}</Text>
            <IconComponent name="GeneralActionsQuestion" boxSize="4" />
          </HStack>
        </HStack>
        {coverage ? (
          <StarRating
            starCount={getCoverageRatingForBase(coverage)}
            color="orange"
          />
        ) : (
          <IconComponent
            name="IconActionClose"
            color="danger.main"
            boxSize={8}
          />
        )}
      </HStack>
      <Collapse in={isOpen && !!description}>
        <VStack align="stretch" spacing="4" pt="2">
          <Text
            pl="14"
            color="text.gray"
            dangerouslySetInnerHTML={{ __html: description || '' }}
          />
          <Divider color="gray.50" />
        </VStack>
      </Collapse>
    </VStack>
  );
};

export default OfferCoverage;
